import { h } from 'preact'
import { useEffect, useRef } from 'preact/hooks'
import PropTypes from 'prop-types'

export default function VideoView({
  track,
  mirror = false,
  className = '',
  objectFit = 'contain',
}) {
  const videoRef = useRef(null)

  useEffect(() => {
    const el = videoRef.current
    if (!el || !track) return
    // Prevent Safari native controls
    el.controls = false
    el.setAttribute('webkit-playsinline', 'true')
    el.setAttribute('x-webkit-airplay', 'deny')
    track.attach(el)
    return () => { track.detach(el) }
  }, [track])

  if (!track) return null

  return <video
    ref={videoRef}
    className={`VideoView ${className}`}
    autoPlay
    playsInline
    muted
    controls={false}
    disablePictureInPicture
    disableRemotePlayback
    controlsList="nodownload nofullscreen noremoteplayback noplaybackrate"
    style={{
      objectFit,
      transform: mirror ? 'scaleX(-1)' : undefined,
      width: '100%',
      height: '100%',
      pointerEvents: 'none',
    }}
  />
}

VideoView.propTypes = {
  track: PropTypes.object,
  mirror: PropTypes.bool,
  className: PropTypes.string,
  objectFit: PropTypes.string,
}
